    <div class="container-fluid page-content">

        <div class="row">
            <div class="col">
                <label class="title">Almacenes</label>
            </div>
        </div>

        <div class="row">
            <div class="col text-end">
                <button (click)="abrirModalCrearAlmacen()" class="btn btn-sm btn-success rounded-button">
                    <i class="fas fa-plus"></i>&nbsp;
                    Nuevo almacén
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <p-table #dt [value]="lista" [scrollable]="true" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="codigo"  style="border-top-left-radius: 15px;" class="medium-col">Código</th>
                        <th pSortableColumn="idEstacion" class="medium-col">Estación</th>
                        <th pSortableColumn="descripcion" class="medium-col">Descripción</th>
                        <th pSortableColumn="idCombustible" class="medium-col">Tipo de Combustible</th>
                        <th pSortableColumn="idEstatus" class="medium-col">Estatus</th>
                        <th pSortableColumn="idSite" class="medium-col">Site</th>
                        <th class="medium-col" style="border-top-right-radius: 15px;">Acción</th>
                    </tr>

                    <tr class="filter-row">
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCodigo type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroCodigo.value, 'codigo', 'contains')">
                        </th>
                        <th>
                            <input placeholder="Filtrar" type="text" #filtroEstacion class="form-input form-input-table-filter" (input)="dt.filter(filtroEstacion.value, 'idEstacion', 'contains')">
                        </th>
                        <th>
                            <input placeholder="Filtrar" type="text" #filtroDescripcion class="form-input form-input-table-filter" (input)="dt.filter(filtroDescripcion.value, 'descripcion', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCombustible type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroCombustible.value, 'idCombustible', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroEstatus type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroEstatus.value, 'idEstatus', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroSite type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroSite.value, 'idSite', 'contains')">
                        </th>
                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-almacen>
                    <tr>
                        <td class="medium-col">{{almacen.codigo}}</td>
                        <td class="medium-col">{{almacen.idEstacion }}</td>
                        <td class="medium-col">{{almacen.descripcion}}</td>
                        <td class="medium-col">{{almacen.idCombustible}}</td>
                        <td class="medium-col">{{almacen.idEstatus}}</td>
                        <td class="medium-col">{{almacen.idSite}}</td>
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalEditarAlmacen(almacen)" style="font-size:12px; width: 100px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="far fa-edit"></i>&nbsp;
                                Editar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>

    </div>